const getYear = () => {
  const year = window?.location?.pathname?.split("/")[1] || 2026;
  return year;
};

export default getYear;
